import { createShapeFromBakedRules } from "../createShapeFromBakedRules";
// TODO: createLayoutShape is trouble... big trouble
// TODO: change to returning geometry
export function createLayoutShape(bakedRules, params) {
    try {
        const shape = createShapeFromBakedRules(bakedRules, 0);
        // TODO: great comments below, review this createShapeFromBakedRules(..) behavior - arguably an empty
        // svg result should return undefined to simplify the function's contract
        if (shape && !shape.curves.length) {
            // If the shape is empty, it likely means the SVG path couldn't be parsed.
            // Return undefined instead of an invalid empty layout shape (which calling
            // code would break on.)
            return undefined;
        }
        return shape;
    }
    catch (error) {
        if (params?.throwException) {
            throw error;
        }
        else {
            return undefined;
        }
    }
}
//# sourceMappingURL=createLayoutShape.js.map